import { ICustomer } from "./epcCustomer.model";
import { IProduct } from "./productData.model";
import ISerialNumber from "./serialNumber.model";
import { IWarehouseRawMaterial } from "./warehouseRawMaterial.model";

export enum IOrderValidation {
  pending = "pending",
  approved = "approved",
  rejected = "rejected",
  cancelled = "cancelled",
  credited = "credited",
}

export interface IPaymentDetails {
  payment: boolean;
  paymentPaid: number;
  paymentRemaining: number;
  _id: string;
  utrNumber: string;
  paymentScreenshot: string;
}

export interface IUTRDetails {
  utr: string;
  price: number;
}

export interface IdispatchedQuantity {
  productId: { _id: string; productName: string };
  rawMaterial: { _id: string; name: string };
  type?: "product" | "material";
  productName?: string;
  name?: string;
  quantity: number;
  serialNumbers: string[];
  serialNumbersWithDate: { sn: string; dispatchedDate: Date }[];
}

export interface IOrderGoods {
  type: string;
  unit: string;
  _id: string;
  dispatchedSerials: ISerialNumber[];
  dispatchedQuantity: IdispatchedQuantity[];
  product: IProduct;
  rawMaterial: IWarehouseRawMaterial;
  quantity: number;
  price: number;
  discount?: number;
  gst: number;
  hsn: number;
  invoiceGenerated?: boolean;
  invoiceId?: string;
}

export type TransportMode =
  | "Air"
  | "Sea"
  | "Road"
  | "Rail"
  | "Courier"
  | "Self Pick-up";

export interface ItrackingDetails {
  productIds: string[];
  transportMode: TransportMode;
  _id?: string;
  trackingNumber: string;
  trackingLink: string;
  serialNumbers: ISerialNumber[];
  manualSerialNumbersByProduct?: Record<string, string[]>;
  manualSerialNumbersByMaterial?: Record<string, string[]>;
  pickupName?: string;
  transporterName?: string;
  transporterMobile?: string;
  vehicleNumber?: string;
}

export interface IDispatchHistory {
  dispatchDate: Date;
  transportMode: string;
  trackingNumber?: string;
  trackingLink?: string;
  serialNumbers: { sn: string }[];
  manualSerialNumbersByProduct?: Record<string, string[]>;
  manualSerialNumbersByMaterial?: Record<string, string[]>;
  pickupName?: string;
  transporterName?: string;
  transporterId?: string;
  transporterMobile?: string;
  vehicleNumber?: string;
  vehicleType?: "R" | "O";
  distance?: number;
}

export interface IProductSnEntry {
  product: string;
  serialNumbers: string[];
  _id?: string;
}

export interface IDispatchQuantity {
  productId: string;
  quantity: number;
  serialNumbers: string[];
}

interface IproductRegistration {
  name?: string;
  address?: string;
  area?: string;
  consumerNumber?: string;
  registrationNumber?: string;

  panelMake?: string;
  panelCapacity?: string;
  panelVoltage?: string;

  inverterMake?: string;
  inverterCapacity?: string;
  inverterVoltage?: string;

  numberOfModules?: string;
  totalSolarCapacity?: string | null;
  installationDate?: Date;

  panelBarcodes?: string[];
  inverterBarcodes?: string[];

  geoPhoto?: {
    name: string;
    link: string;
  };

  registeredAt?: Date;
}

interface IWhatsappCustomer {
  _id: string;
  customerName: string;
  productRegistration?: IproductRegistration;
}

export interface IAssignmentItem {
  itemId: string;
  quantity: number;
  type: "product" | "material";
}

export interface IAssignmentHistory {
  items: IAssignmentItem[];
  assignedBy: string;
  assignedAt: Date;
}

export interface IOrderAddress {
  line1?: string;
  line2?: string;
  city?: string;
  state?: string;
  pincode?: string;
  address?: string;
}

export interface IOrder {
  assignmentHistory: IAssignmentHistory[];
  whatsappCustomerId: IWhatsappCustomer;
  createdAt: string | number | Date;
  updatedAt: string | number | Date;
  salesRep?: any;
  quotationNumber?: string;
  bomId?: any;
  orderNumber: string;
  gstin?: string;
  plantSize: string;
  dispatchQuantity: IdispatchedQuantity[];
  totalAmount: number;
  createdDate: string | number | Date;
  goods: IOrderGoods[];
  dispatchedGoods: IOrderGoods[]; // Contains fully dispatched items
  orderStatuspaymentDetails: IPaymentDetails;
  order: any;
  orderStatus: string;
  customerId: ICustomer;
  _id: string;
  customerName: string;
  serialNumber: string;
  trackingLink: string;
  paymentDetails: IPaymentDetails;
  trackingNumber: string;
  transportMode: string;
  trackingDetails?: any[];
  dispatchHistory: IDispatchHistory[];
  dispatch?: string;
  cancelledOrder?: boolean;
  transportPrice?: number;
  discountPrice: number;
  creditStatus: string;
  creditRequestedBy: { _id: string; name: string };
  creditApprovalHistory?: CreditApprovalHistory[];
  shippingAddress?: IOrderAddress;
  billingAddress?: IOrderAddress;
  invoice: {
    generated: boolean;
    invoiceId: invoiceMeta[];
    status: "NOT_GENERATED" | "GENERATED" | "CANCELLED" | "PARTIAL";
  };
  createdBy?: { _id: string; username: string };
  author?: { _id: string; username: string };
  cse?: { _id: string; username: string };
}

export interface invoiceMeta {
  invoiceNumber: string;
  _id: string;
  createdAt: Date;
}
interface CreditApprovalHistory {
  status: CreditApprovalStatus;
  remark?: string;
  approvedBy?: string;
  date: Date;
  approvedAmount?: number;
}

export enum CreditApprovalStatus {
  requested = "requested",
  approved = "approved",
  rejected = "rejected",
  cancelled = "cancelled",
}

export interface CustomerOrder {
  _id: string;
  productName: string;
  hsn: number | string;
  price: number;
  gst: number;
  productId: IProduct;
  transportPrice?: number;
  discountPrice: number;
  quantity: number;
}

export interface OrderItem {
  productName: string;
  price: number;
  quantity: number;
  transportPrice?: number;
  discountPrice: number;
}
